import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';

/**
 * Card component - a generic container with semantic styling
 * Uses semantic color classes from shared configuration
 */
export const Card = ({ children, className = '', variant = 'default', ...props }) => {
  const colors = useColors();
  const semantic = colors.semantic;

  // Choose semantic classes based on variant
  const cardClasses = variant === 'content' 
    ? `${semantic.contentCardBg} ${semantic.contentCardBorder} rounded-xl shadow-lg`
    : `${semantic.contentCardBg} ${semantic.contentCardBorder} rounded-lg shadow-md`;

  return (
    <div className={`${cardClasses} overflow-hidden ${className}`} {...props}>
      {children}
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'content']),
};

/**
 * CardHeader component - the header section of a card
 */
export const CardHeader = ({ children, className = '', ...props }) => {
  const colors = useColors();
  const semantic = colors.semantic;

  return (
    <div className={`p-4 border-b ${semantic.contentCardBorder} ${semantic.contentCardHeading} ${className}`} {...props}>
      {children}
    </div>
  );
};

CardHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

/**
 * CardContent component - the content section of a card
 */
export const CardContent = ({ children, className = '', ...props }) => {
  const colors = useColors();
  const semantic = colors.semantic;

  return (
    <div className={`p-4 ${semantic.contentCardText} ${className}`} {...props}>
      {children}
    </div>
  );
};

CardContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

/**
 * CardFooter component - the footer section of a card
 */
export const CardFooter = ({ children, className = '', ...props }) => {
  const colors = useColors();
  const semantic = colors.semantic;

  return (
    <div className={`p-4 border-t ${semantic.contentCardBorder} ${semantic.contentCardText} ${className}`} {...props}>
      {children}
    </div>
  );
};

CardFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

// Default export for the main Card component
export default Card;

